module.exports = __webpack_public_path__ + "static/media/image_3.944d6af7.png";